import React, { useState } from "react";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/send-contact-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setStatus("Message sent successfully!");
        setFormData({ mobile: "", email: "", subject: "", message: "" });
      } else {
        setStatus(data.error || "Failed to send the message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setStatus("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="contact-us-container">
      <h2>Contact Us</h2>
      <h3>&nbsp;&nbsp;&nbsp;&nbsp;Mobile Number : 971567188995 </h3>
      <h3>&nbsp;&nbsp;&nbsp;&nbsp;Email Id : equityfinx@gmail.com </h3>
      <br/>
      <form className="contact-us-form" onSubmit={handleSubmit}>
        <label>
          Mobile Number:
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Enter your mobile number"
            required
          />
        </label>

        <label>
          Email ID:
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            required
          />
        </label>

        <label>
          Subject:
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Enter subject"
            required
          />
        </label>

        <label>
          Message:
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message here"
            rows="5"
            required
          />
        </label>

        <button type="submit" className="contact-us-button">
          Send Message
        </button>
      </form>
      {status && <p className="status-message">{status}</p>}
    </div>
  );
};

export default ContactUs;
